
        require('./index.scss');
        'use strict';

var _feedback = require('./model/service/feedback.js');

var _feedback2 = _interopRequireDefault(_feedback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $dlg = {}; // modify from front-pc


var cfloatDlg = require('./cf-dlg.js');
// 验证失败显示
function errorHint(text) {
    var errorToast = $('.module-common-float-dlg').find('[node-type="warn-tag-err"]');
    if (text) {
        errorToast.find('.error-text').text(text);
    }
    errorToast.show(100).delay(2000).fadeOut(200);
}
var cookie = {
    feedbackCount: 0,
    errorCount: 0,
    getCookie: function getCookie(name) {
        var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        var arr = window.document.cookie.match(reg);
        if (!!arr) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    },
    setCookie: function setCookie(name, value) {
        var exp = new Date();
        exp.setHours(23);
        exp.setMinutes(59);
        exp.setSeconds(59);
        // today.setTime(exp.getTime());
        window.document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
    },
    getFeedbackCount: function getFeedbackCount() {
        return this.feedbackCount;
    },
    addFeedbackCount: function addFeedbackCount() {
        this.feedbackCount++;
        this.setCookie('feedback', '' + this.feedbackCount);
    },
    getErrorCount: function getErrorCount() {
        return this.errorCount;
    },
    addErrorCount: function addErrorCount() {
        this.errorCount++;
        this.setCookie('error', '' + this.errorCount);
    },
    init: function init() {
        this.feedbackCount = parseInt(this.getCookie('feedback'), 10);
        this.errorCount = parseInt(this.getCookie('error'), 10);
    }

};

var ruzhuRender = function ruzhuRender($mod, data) {};

var feedbackRender = function feedbackRender($mod, data) {
    $mod.find('[data-placeholder]').focus(function () {
        var $curInput = $(this);
        var placeholder = $curInput.data('placeholder');
        if ($curInput.val() == '' || $curInput.val() == placeholder) {
            $curInput.removeClass('grey');
            $curInput.val('');
        }
    }).blur(function () {
        var $curInput = $(this);
        var placeholder = $curInput.data('placeholder');
        if ($curInput.val() == '' || $curInput.val() == placeholder) {
            $curInput.addClass('grey');
            $curInput.val(placeholder);
        }
    }).blur();

    $mod.find('[node-type="panel-submit"]').click(function () {
        var thisDom = $(this);
        if (!$mod.find('[node-type="privacy-checkbox"]').hasClass("checked")) {

            errorHint('请同意相关协议');

            return;
        }
        if (!thisDom.hasClass('active')) {
            return;
        }
        if (cookie.getFeedbackCount() > 10) {
            $mod.find('.error-txt').text('每日提交建议不能超过10次。').show();
            return;
        }

        var subContact = $mod.find('[node-type="panel-input-concat"]').val();
        var subText = $mod.find('[node-type="panel-text"]').val();
        // var checkCode = $mod.find('[node-type="panel-checkcode"]').val();
        if (subContact == '请输入您的联系方式') {
            subContact = '';
        }
        if (subText == '请在此填写您的意见') {
            subText = '';
        }
        if (subText == '') {
            $mod.find('.error-txt').text('您还没有填写您的意见。').show();
            return;
        } else {
            $mod.find('.error-txt').hide();
        }

        var subData = {
            contact: subContact,
            content: subText,
            url: window.location.href
        };

        _.extend(subData, data);

        _feedback2['default'].submitFeedback(subData).then(function (res) {
            if (res.code === 200) {
                thisDom.hide();
                $mod.find('.panel-form').hide();
                $mod.find('.panel-result').show();
                cookie.addFeedbackCount();
            } else {
                $mod.find('.error-txt').text(res.msg).show();
            }
        });
    });

    $mod.find('[node-type="panel-close"]').click(function () {
        $dlg.close();
    });
};

var errorRender = function errorRender($mod, data) {
    $mod.find('[data-placeholder]').focus(function () {
        var $curInput = $(this);
        var placeholder = $curInput.data('placeholder');
        if ($curInput.val() == '' || $curInput.val() == placeholder) {
            $curInput.removeClass('grey');
            $curInput.val('');
        }
    }).blur(function () {
        var $curInput = $(this);
        var placeholder = $curInput.data('placeholder');
        if ($curInput.val() == '' || $curInput.val() == placeholder) {
            $curInput.addClass('grey');
            $curInput.val(placeholder);
        }
    }).blur();

    $mod.find('[node-type="panel-submit"]').click(function () {
        if (!$mod.find('[node-type="privacy-checkbox"]').hasClass("checked")) {

            errorHint('请同意相关协议');

            return;
        }
        var thisDom = $(this);
        if (!thisDom.hasClass('active')) {
            return;
        }

        if (cookie.getErrorCount() > 10) {
            $mod.find('.error-txt').text('每日提交建议不能超过10次。').show();
            return;
        }

        var subContact = $mod.find('[node-type="panel-input-concat"]').val();
        var subText = $mod.find('[node-type="panel-text"]').val();
        if (subContact == '请输入您的联系方式') {
            subContact = '';
        }
        if (subText == '请在此填写您的意见') {
            subText = '';
        }
        // var checkCode = $mod.find('[node-type="panel-checkcode"]').val();
        if (subText == '') {
            $mod.find('.error-txt').text('您还没有填写您的意见。').show();
            return;
        } else {
            $mod.find('.error-txt').hide();
        }

        var subData = {
            contact: subContact,
            content: subText,
            url: window.location.href
        };

        _.extend(subData, data);

        _feedback2['default'].submitError(subData).then(function (res) {
            if (res.code === 200) {
                thisDom.hide();
                $mod.find('.panel-form').hide();
                $mod.find('.panel-result').show();
                cookie.addErrorCount();
            } else {
                $mod.find('.error-txt').text(res.msg).show();
            }
        });
    });

    $mod.find('[node-type="panel-close"]').click(function () {
        $dlg.close();
    });
};

var modInit = function modInit($mod) {
    cookie.init();
    $mod.find('[node-type="privacy-checkbox"]').click(function () {
        $(this).toggleClass("checked");
    });

    var cityId = $mod.attr('data-cityid');
    var projectName = $mod.attr('data-pname');
    var source = $mod.attr('data-source');
    var infoid = $mod.attr('data-infoid');
    var data = {};

    data.cityId = cityId;

    if (projectName !== '') {
        data.projectName = projectName;
    }
    if (source !== '') {
        data.source = source;
    }
    if (infoid !== '') {
        data.infoId = infoid;
    }

    var dlgType = $mod.find('.cfdlg-panel').data('type');
    if (dlgType === 'ruzhu') {
        ruzhuRender($mod, data);
    } else if (dlgType === 'feedback') {
        feedbackRender($mod, data);
    } else if (dlgType === 'error') {
        errorRender($mod, data);
    }

    $mod.find('.cfdlg-btnclose').click(function () {
        $dlg.close();
    });
};

Event.on('feedback-dialog_show', function (cmd, data) {
    var dlgData = _.extend({}, data);

    switch (cmd) {
        case 'ruzhu':
            dlgData.dlgtype = 'ruzhu';
            dlgData.width = '525px';
            break;
        case 'feedback':
            dlgData.dlgtype = 'feedback';
            dlgData.width = '440px';
            break;
        case 'error':
            dlgData.dlgtype = 'error';
            dlgData.width = '440px';
            break;
        default:
            return;
    }

    var tpl = require('./page.html'),
        render = velocityjs.render(tpl, dlgData);

    var $mod = $(render);

    cfloatDlg($mod, dlgData, function (dlg) {
        $dlg = dlg;
        modInit($mod);
    });
});;
    


// WEBPACK FOOTER //
// ./~/@front-end/common-module-vm/feedback-dialog/index.js